import React, { useState, useEffect } from "react";
import { Space, Table, Tag, Select,Flex } from 'antd';
import { Link } from "react-router-dom";
import fetchData from "Hooks/useAPI";
import './style.css'
import useAuth from "Hooks/useAuth";
import Card from "components/card";



const CardPromocionesAPI = () => {
  /*const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [dataSource, setDataSource] = useState([]);
  const [empresa, setEmpresa] = useState("all")
  const [totalData, setTotalData] = useState(0);
  const { logout } = useAuth()
  const URL = `https://adandyou.host/users_app/api/index.php/ventanuevo?pagina=${currentPage}&porPagina=${pageSize}&empresa=${empresa}`
  
  useEffect(() => {
    fetchData(URL, 'GET', null, {}, logout)
    .then(response=>{
      setDataSource(response.items.data);
      setTotalData(response.items.total);
    })
    .catch((err)=>{
      console.log(err)
    })
    
  }, [currentPage, pageSize,empresa]);



  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };
*/
  return (
    <Card extra={"w-full h-full sm:overflow-auto px-6"}>        
        <div className="mt-8 overflow-x-scroll xl:overflow-x-hidden">
            <div className="text-2xl font-semibold text-center text-navy-700 dark:text-white">
                PRÓXIMAMENTE
            </div>
            {/* aquí agregamos contenido cuando se tenga */}
        </div>
    </Card>
  );
};



export default CardPromocionesAPI;